import React, { useState, useEffect } from 'react';
import CountUp from 'react-countup';
import apiService from '../services/api.service';
import './HomeStatsSection.css';

const HomeStatsSection = () => {
  const [stats, setStats] = useState({
    exhibitors: 0,
    cities: 0,
    visitors: 0,
    buyers: 0
  });
  const [loading, setLoading] = useState(true);
  const [startCounter, setStartCounter] = useState(false);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const response = await apiService.getPublicStats();
      if (response.data.success) {
        setStats(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
      setStartCounter(true);
    }
  };

  const statItems = [
    {
      icon: 'fas fa-store',
      label: 'Exhibitors',
      value: stats.exhibitors
    },
    {
      icon: 'fas fa-map-marked-alt',
      label: 'Cities Road Shows',
      value: stats.cities
    },
    {
      icon: 'fas fa-users',
      label: 'Visitors',
      value: stats.visitors
    },
    {
      icon: 'fas fa-user-tie',
      label: 'Hosted Buyers',
      value: stats.buyers
    }
  ];

  if (loading) {
    return (
      <div className="facts facts-loading">
        <div className="container">
          <div className="text-center">Loading statistics...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="facts">
      <div className="container">
        <div className="row">
          {statItems.map((item, index) => (
            <div key={index} className="col-lg-3 col-md-6">
              <div className="facts-item">
                <i className={item.icon}></i>
                <div className="facts-text">
                  <h3 className="facts-plus">
                    {startCounter ? (
                      <CountUp
                        end={item.value}
                        duration={2}
                        separator={item.value > 999 ? ',' : ''}
                      />
                    ) : (
                      '0'
                    )}
                  </h3>
                  <p>{item.label}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeStatsSection;
